module.exports = __webpack_public_path__ + "img/carpet_two.2ddb411f.png";